import React from "react";
import styled from 'styled-components'
import { motion } from 'framer-motion'
import FadeIn from "components/shared/motion/FadeIn";
import CallToActionButton from "components/shared/buttons/CallToActionButton";

const ShareButtonContainer = styled.div.attrs({
	className: "w-full p-5 flex items-center justify-center"
})``;

export default ({ onClick }) => (
	<FadeIn>
		<ShareButtonContainer>
			<CallToActionButton onClick={onClick}>Gift story for free</CallToActionButton>
		</ShareButtonContainer>
	</FadeIn>
);
